import { createContext } from "react"

import {
    ANTITAGS_FILTER,
    ATTACHMENT_TYPE_FILTER,
    AUTHOR_FILTER,
    DATE_FROM_FILTER,
    DATE_TO_FILTER,
    FILE_NAME_FILTER,
    FILE_TYPE_FILTER,
    TAGS_FILTER,
} from "../../constants/filters"

export const initialState = {
    filters: {
        [ANTITAGS_FILTER]: [],
        [ATTACHMENT_TYPE_FILTER]: [],
        [AUTHOR_FILTER]: [],
        [DATE_FROM_FILTER]: null,
        [DATE_TO_FILTER]: null,
        [FILE_NAME_FILTER]: "",
        [FILE_TYPE_FILTER]: [],
        [TAGS_FILTER]: [],
    },
}

const initialDispatch = {}

export const DocumentStateContext = createContext(initialState)
export const DocumentDispatchContext = createContext(initialDispatch)